import { FormFieldConfig, FormFieldType } from "../../interface";

export const UPLOAD_CONFIG = {
  acceptedTypes: ["csv"],
  maxSizeMb: 2,
  showSelection: false, // not used here, allows us to use ready-made validation function
  allowRemoveExistingFile: false, // not used here
};

export const CSV_DELIMITER = ",";

export const ERRORS = {
  IMPORT: "An error occurred. Was unable to import the CSV file.",
  GET: "Could not get current settings. Please try again later.",
  UPDATE: "An error occurred. Could not update the facility's settings.",
};

export const COLUMN_CONFIGS = [
  {
    label: "Facility Id",
    key: "facilityId",
    template: "valueTpl",
  },
  {
    label: "PCC Code",
    key: "facility_code",
    template: "valueTpl",
  },
  {
    label: "State",
    key: "prov",
    template: "valueTpl",
  },
  {
    label: "Name",
    key: "name",
    template: "valueTpl",
  },
  {
    label: "Display Name",
    key: "displayName",
    template: "textInputTpl",
  },
  {
    label: "Owner Active",
    key: "ownerActive",
    template: "checkboxTpl",
  },
  {
    label: "Reports Active",
    key: "reportsActive",
    template: "checkboxTpl",
  },
  {
    label: "Referral Active",
    key: "referralActive",
    template: "checkboxTpl",
  },
  {
    label: "Assisted Living",
    key: "assistedLiving",
    template: "checkboxTpl",
  },
];

export const CHECKBOX_CONFIG_DEFAULT: FormFieldConfig = {
  label: "",
  key: "",
  type: FormFieldType.Checkbox,
};

export const TEXTINPUT_CONFIG_DEFAULT: FormFieldConfig = {
  label: "",
  key: "",
  type: FormFieldType.Text,
};
